import React,{ useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { downloadCsv } from '../common/sharedFunctions';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate,useLocation } from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import {SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import BlankTable from '../components/Table/BlankTable';
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

export default function Users() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const navigate = useNavigate();
  const {
    deleteUser,
    fetchUsersOnce,
    checkUserExists,
    mainSignUp
  } = api;
  const [data, setData] = useState([]);
  const [sortedData, SetSortedData] = useState([]);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [createUserLoading, setCreateUserLoading] = useState(false);
  const [newUserData, setNewUserData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    usertype: 'support'
  });
  
  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(()=>{
    dispatch(fetchUsersOnce());
},[dispatch,fetchUsersOnce]);

  useEffect(()=>{
    if(staticusers){
      setData(staticusers.filter(user => ['admin', 'manager', 'support'].includes(user.usertype)));
    }else{
      setData([]);
    }
    loaded.current = true;
  },[staticusers]);

  useEffect(()=>{
    if(data){
      SetSortedData(data.sort((a,b)=>(moment(b.createdAt) - moment(a.createdAt))))
    }
  },[data])

  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable:'never', defaultSort:'desc', render: rowData => rowData.createdAt ? moment(rowData.createdAt).format('lll') : null},
    { title: t('first_name'), field: 'firstName', initialEditValue: ''},
    { title: t('last_name'), field: 'lastName', initialEditValue: ''},
    { title: t('usertype'), field: 'usertype', editable: 'never' },
    { title: t('mobile'), field: 'mobile', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.mobile : t("hidden_demo")},
    { title: t('email'), field: 'email', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.email : t("hidden_demo"),headerStyle:{textAlign:'center'}},
    {
      title: t("signup_location"),
      field: "signup_location",
      editable: "never",
      render: (rowData) => rowData.signup_location || "N/A",
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: 40 }} />
        ),
      editable: "never",
  },
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  const handleCreateDialogOpen = () => {
    setCreateDialogOpen(true);
  };

  const handleCreateDialogClose = () => {
    if (!createUserLoading) {
      setCreateDialogOpen(false);
      setNewUserData({ firstName: '', lastName: '', email: '', password: '', usertype: 'admin' });
    }
  };

  const handleCreateFieldChange = (event) => {
    setNewUserData((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleCreateUser = async () => {
    if (!settings.AllowCriticalEditsAdmin) {
      alert(t('demo_mode'));
      return;
    }

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!newUserData.firstName.trim()) {
      alert('First name is required');
      return;
    }
    if (!newUserData.lastName.trim()) {
      alert('Last name is required');
      return;
    }
    if (!emailRegex.test(newUserData.email)) {
      alert(t('proper_email'));
      return;
    }
    if (!newUserData.password || newUserData.password.length < 8) {
      alert('Password must be at least 8 characters');
      return;
    }

    try {
      setCreateUserLoading(true);
      const existing = await checkUserExists({ email: newUserData.email });
      if ((existing.users && existing.users.length > 0) || existing.error) {
        alert(existing.error ? t('email_or_mobile_issue') : t('user_exists'));
        return;
      }

      const payload = {
        firstName: newUserData.firstName.trim(),
        lastName: newUserData.lastName.trim(),
        email: newUserData.email.trim(),
        password: newUserData.password,
        usertype: newUserData.usertype,
        approved: true,
        createdAt: new Date().getTime(),
      };

      const res = await mainSignUp(payload);
      if (res && res.uid) {
        dispatch(fetchUsersOnce());
        handleCreateDialogClose();
        alert('User created successfully');
      } else {
        alert(t('reg_error'));
      }
    } catch (error) {
      alert(t('reg_error'));
    } finally {
      setCreateUserLoading(false);
    }
  };

  return (
    !loaded.current? <CircularLoading/>:
    <ThemeProvider theme={theme}>
      { sortedData?.length >0 ? 
    <MaterialTable
      title={t('alladmins_title')}
      columns={columns}
      onChangePage={(page)=>HandalePageChange(page)}
      style={{
        direction: isRTL === "rtl" ? "rtl" : "ltr",
        borderRadius: "8px",
        boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        padding: "20px",
      }}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={{
        initialPage:state?.pageNo,
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString()
            let dArr = [];
            for(let i=0;i< hArray.length; i++) {
              dArr.push(row[hArray[i]]);
            }
            return Object.values(dArr);
          })
          const { exportDelimiter } = ",";
          const delimiter = exportDelimiter ? exportDelimiter : ",";
          const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        maxColumnSort: "all_columns",
        rowStyle: (rowData) => ({
          backgroundColor:
            selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
        }),
        ...TableStyle()
      }}
      localization={localization(t)}
      editable={{
        onRowDelete: oldData =>
          settings.AllowCriticalEditsAdmin?
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              if(oldData.id === 'admin0001'){
                alert(t('first_admin_deleted'));
              }else{
                dispatch(deleteUser(oldData.id));
                dispatch(fetchUsersOnce());
              }
            }, 600);
          })
          :
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              alert(t('demo_mode'));
            }, 600);
          })
          , 
      }}


      actions={[
        {
          icon: 'add',
          tooltip: t("add_admin"),
          isFreeAction: true,
          onClick: handleCreateDialogOpen,
          
        },
        {
          icon: 'edit',
          tooltip: t("edit"),
          onClick: (event,rowData) => navigate(`/users/edituser/admin/${rowData.id}`,{state:{pageNo:currentPage}})
        },
        
       
      ]}
    />
     :  <BlankTable title={t('alladmins_title')} 
     actions={[
      {
        icon: 'add',
        tooltip: t("add_admin"),
        isFreeAction: true,
        onClick: handleCreateDialogOpen,
        
      },
    ]}
     columns={columns}  data={[]} localization={localization(t)} options={TableStyle()}/>} 
     <Dialog open={createDialogOpen} onClose={handleCreateDialogClose} fullWidth maxWidth="sm">
      <DialogTitle>Create New User</DialogTitle>
      <DialogContent>
        <TextField
          id="create-user-first-name"
          margin="dense"
          label="First Name"
          fullWidth
          name="firstName"
          value={newUserData.firstName}
          onChange={handleCreateFieldChange}
        />
        <TextField
          id="create-user-last-name"
          margin="dense"
          label="Last Name"
          fullWidth
          name="lastName"
          value={newUserData.lastName}
          onChange={handleCreateFieldChange}
        />
        <TextField
          id="create-user-email"
          margin="dense"
          label="Email"
          fullWidth
          type="email"
          name="email"
          value={newUserData.email}
          onChange={handleCreateFieldChange}
        />
        <TextField
          id="create-user-password"
          margin="dense"
          label="Password"
          fullWidth
          type="password"
          name="password"
          value={newUserData.password}
          onChange={handleCreateFieldChange}
        />
        <FormControl margin="dense" fullWidth>
          <InputLabel id="staff-usertype-label">User Type</InputLabel>
          <Select
            id="create-user-usertype"
            labelId="staff-usertype-label"
            name="usertype"
            value={newUserData.usertype}
            label="User Type"
            inputProps={{ name: 'usertype', id: 'create-user-usertype-input' }}
            onChange={handleCreateFieldChange}
          >
            <MenuItem value="admin">admin</MenuItem>
            <MenuItem value="manager">manager</MenuItem>
            <MenuItem value="support">support</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCreateDialogClose} disabled={createUserLoading}>Cancel</Button>
        <Button onClick={handleCreateUser} variant="contained" disabled={createUserLoading}>
          {createUserLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
     </ThemeProvider>
  );
}
